// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zoom-image_imageWrapper__oev7i","image":"zoom-image_image__g8+Yi"};